/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import {
  Box, Grid, List, ListItem, ListItemIcon, ListItemText, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import theme from '../../../../../Config/ThemeConfig';

/**
 * FeaturePreview Component
 * @returns {JSX.Element}
 * @constructor
 */
export function FeaturePreview() {
  const { t } = useTranslation('translations');
  const {
    values: { rateBundle },
  } = useFormikContext();

  return (
    <Grid container mt={4}>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontWeight: 'bold',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            color: '#49ad33',
          }}
        >
          {t('featurePreviewHeader')}
        </Typography>
        {rateBundle?.modules.length > 0 ? (
          <List
            dense
            sx={{
              display: 'flex',
              flexDirection: {
                xs: 'column',
                sm: 'row',
              },
              flexWrap: 'wrap',
            }}
          >
            {rateBundle?.modules.map((service) => (
              <ListItem
                key={service.name}
                sx={{
                  px: 0,
                  width: '50%',
                }}
              >
                <ListItemIcon sx={{
                  minWidth: 0,
                  mr: '1rem',
                }}
                >
                  <CheckCircleOutlineIcon sx={{ fill: theme.palette.primary.main }} />
                </ListItemIcon>
                <ListItemText primary={service.name} />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box>
            <Typography sx={{ fontSize: '0.875rem' }}>{t('noServicesIncluded')}</Typography>
          </Box>
        )}

      </Grid>
    </Grid>
  );
}
